<div class="container-fluid login-component">
    <div class="login-page d-flex flex-column justify-content-center align-items-center">
        <h4 class="auth-heading">Forgot Password</h4>
        <div>
            <form class="custom-form" [formGroup]="forgotPasswordForm" (ngSubmit)="forgotPasswordHandle()">
                <div class="form-control-box form-group bottom-spacing">
                    <label for="email">Email : </label>
                    <input type="email" name="email" class="form-control" placeholder="Enter Email Address"
                        formControlName="vEmail">
                </div>
                <div class="text-center bottom-spacing">
                    <button type="submit" class="active-btn btn w-100 mt-3">Forgot Password</button>
                </div>
            </form>
            <div class="text-center sign-up">
                Already have an account ? <button class="grey-text" routerLink="/login">Sign In</button>
                here.
            </div>
        </div>
    </div>
</div>